module.exports = __webpack_public_path__ + "static/media/pomagranate.f86f5ab0.jpg";